export type SkeletonVariant = 'card' | 'list-item' | 'text'

interface SkeletonLoaderProps {
  variant: SkeletonVariant
  count?: number
}

export default function SkeletonLoader({ variant, count = 1 }: SkeletonLoaderProps) {
  const items = Array.from({ length: count }, (_, i) => i)

  if (variant === 'card') {
    return (
      <>
        {items.map((i) => (
          <div
            key={i}
            className="h-[200px] bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 rounded-lg animate-pulse bg-[length:200%_100%]"
            style={{ animationDuration: '1.5s' }}
          />
        ))}
      </>
    )
  }

  if (variant === 'list-item') {
    return (
      <>
        {items.map((i) => (
          <div
            key={i}
            className="h-12 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 rounded animate-pulse bg-[length:200%_100%]"
            style={{ animationDuration: '1.5s' }}
          />
        ))}
      </>
    )
  }

  // text variant - 3 lines of varying width
  return (
    <>
      {items.map((i) => (
        <div key={i} className="space-y-3">
          <div
            className="h-4 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 rounded w-full animate-pulse bg-[length:200%_100%]"
            style={{ animationDuration: '1.5s' }}
          />
          <div
            className="h-4 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 rounded w-5/6 animate-pulse bg-[length:200%_100%]"
            style={{ animationDuration: '1.5s', animationDelay: '0.1s' }}
          />
          <div
            className="h-4 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 rounded w-4/6 animate-pulse bg-[length:200%_100%]"
            style={{ animationDuration: '1.5s', animationDelay: '0.2s' }}
          />
        </div>
      ))}
    </>
  )
}
